// this file is only used by webpack dev server - only for local development

export default {
  apiUrl: "https://api.hv-verkeerseducatie-dev.aws-public.anwb.cloud/",
  learningRecordApiUrl:
    "https://api.hv-verkeerseducatie-dev.aws-public.anwb.cloud/learning-record/",
  registerUrl: "https://register.hv-verkeerseducatie-dev.aws-public.anwb.cloud/",
};
